import { useTranslation } from 'react-i18next'
import { cx } from '../utils/cx'
import type { CameraViewerProps } from './types'
import './CameraViewer.css'

/**
 * Visor de cámara con guía (bundle B2): marco 3:4 oscuro, máscara rgba(31,27,22,.45), recuadro de documento
 * u óvalo de cara, consejo en píldora. Deja un hueco (`children`) para el DOM del SDK de captura; no lo
 * reimplementa (inventario D9: MobbScan pinta su propio visor dentro de #mobbscan-container).
 */
export function CameraViewer({ guide, hint, children, label, hideGuide, className }: CameraViewerProps) {
  const { t } = useTranslation()
  const ariaLabel = label ?? (guide === 'face' ? t('v2.ds.camera.camaraFrontal') : t('v2.ds.camera.vistaCamara'))
  return (
    <div className={cx('hp-camera', `hp-camera--${guide}`, className)}>
      <div className="hp-camera__feed" role="img" aria-label={ariaLabel}>
        {children}
      </div>
      {!hideGuide && <div className="hp-camera__guide" aria-hidden="true" />}
      <div className="hp-camera__hint">{hint}</div>
    </div>
  )
}
